<template>
  <div class="fund-business-table">
    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        :summary-method="summaryMethod"
        @search-reset="searchResets"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        :class="[{'avue_no_left':!isEdit}]"
        :header-cell-class-name="headerClassName"
      >
        <template slot="menuLeft" v-if="isEdit">
          <el-button
            size="small"
            type="primary"
            
            icon="el-icon-plus"
            @click="handleAdd"
          >
            新建
          </el-button>
          <el-button
            type="primary"
            plain
            size="small"
            
            @click.stop="handleEdit"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.fundManageClientSubFund_del"
            @click.stop="handleDelete"
          >
            删除
          </el-button>
        </template>      
      </avue-crud>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="addData?'新增':'编辑'"
      :visible.sync="dialogShow"
      :close-on-press-escape="true"
      
      :modal-append-to-body="false"
      destroy-on-close
      width="35%"
    >
      <div class="add-person-form-container">
        <avue-form
          ref="addBusinessForm"
          v-model="formData"
          :option="addBusinessInfoConfig"
        >      
        </avue-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogShow = false"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="handleAddBusiness"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  businessListConfig,
  addBusinessInfoConfig
} from "./config.js";
import { mapGetters } from "vuex";
import {  getBusinessList,
          getClientBusinessList,
          submitClientBusiness,
          deleteClientBusiness,
          getClientBusinessDetail
} from "@/api/fund/subfunds"
export default {
  name: 'FundBusinessTable',
  data() {
    return {
      formData: {},
      dialogShow: false,
      showDetail: false,
      tableData: [],
      searchForm: {},
      selectionList: [],
      addData: false,
      tableConfig: businessListConfig(this.getMoney),
      addBusinessInfoConfig: addBusinessInfoConfig(),
      page: {
          currentPage: 1,
          total: 0,
          layout: "total,pager,prev, next",
          background: false,
          pageSize: 10,
      }      
    }
  },
  watch: {
    isEdit: {
      handler(newValue, oldValue) {
        if(newValue == true) {
          this.tableConfig.selection = true
          this.queryTableData()
        }
      },
      immediate: true
    }
  },
  props: {
    fundId: {
      type: String,
      required: true
    },    
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  mounted() {},
  methods: {
    headerClassName(tab){
       
       return 'avue_bgc';
     },
    summaryMethod({ columns, data }) {
      const sums = [];
      let arrays = this.tableConfig.selection?[5,8]:[4,7]
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (arrays.includes(index)) {
            let values = 0;
            data.map(
              (item) =>
                // console.log(Number(item[column.property]))
                (values += Number(item[column.property]))
            );
            // console.log(values);
            sums[index] = `${this.getMoney(values.toFixed(2))}万元`;
          } else {
            sums[index] = "-";
          }
        });
      }
      return sums;
    },

    searchChange(query, done) {
      this.searchForm = query
      this.queryTableData()
      done()
    },

    selectionChange(data) {
      this.selectionList = data
    },

    async queryTableData() {
      let params = {
          basicInfoId: this.fundId,
          current: this.page.currentPage,
          size: this.page.pageSize,
          ...this.searchForm
      }
      let res = {}
      if(this.isEdit || (this.$route.query && this.$route.query.audit == 'true')) {
        res = await getClientBusinessList(params)
      }else {
        res = await getBusinessList(params)
      }
      if(res.data.code == 200) {
        this.tableData = res.data.data.records
        this.page.total = res.data.data.total
      } else {
        this.$message.error(res.data.msg)
      }
    },

    handleEdit() {
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行编辑')
      } else if(this.selectionList.length == 1){
        this.addData = false
        this.dialogShow = true
        this.formData = this.selectionList[0]
      }else {
        this.$message.error('请选择一条数据进行编辑')
      }
    },

    handleDelete() {
      let self = this
      this.$confirm('确定删除选择的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
      type: 'warning'
      }).then( async() => {
        let ids = self.selectionList.map((item) => {
          return item.id
        })
        let res = await deleteClientBusiness({ids: ids.join(',')})
        if(res.data.code == 200){
          self.$message.success('删除成功')
          // 刷新列表
          self.queryTableData()
        }
      }).catch(() => {
          self.$message({
              type: 'info',
              message: '已取消删除'
          });
      });
    },

    handleAdd() {
      this.dialogShow = true
      this.addData = true
      this.formData={
        id: "",
        projectName: '',
        investDate: '',
        industry: '',
        cost: '',
        stockRatio: '',
        totalCollectionAmount: '',
        listingSituation:''
      }
      if(this.$refs.addBusinessForm) this.$refs.addBusinessForm.clearValidate()
    },

    handleAddBusiness() {
      let self = this
      this.$refs.addBusinessForm.validate((valid,done) => {
        done()
        if(valid) {
          self.submitForm()
        }else {
          this.$message.warning('请补全运营情况')
        }
      })
    },

    async submitForm() {
      let params = {
       basicInfoId: this.fundId, 
       ...this.formData
      }
      let res = await submitClientBusiness(params)
      // console.info(res)
      if(res.data.code == 200) {
        this.$message.success(this.formData.id?'修改成功':'新增成功')
        this.queryTableData()
        this.dialogShow = false
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.fund-business-table{
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px 20px !important;
  }
  /deep/ .avue-form__menu--center {
    display: none;
  }
  // /deep/ .avue-crud__menu{
  //   display: none;
  // }
  /deep/.el-table__fixed-footer-wrapper {
    bottom: -51px;
  }
  /deep/.el-table__fixed, .el-table__fixed-right {
    height: calc(100% - 51px) !important;
  }
  /deep/.el-table__fixed-footer-wrapper{
    display: none !important;
  }  
}
/deep/ .avue_no_left {
    .avue-crud__menu {
      display: none;
    }
  }
  /deep/.avue_bgc{
  background: #F6FAFF !important;
  font-weight: 400 !important;
}

/deep/ .el-table {
    border-color: #e0eeff;
}
</style>